// utils/decodeRLE.js
function decodeCompressedCounts(compressedCounts) {
  const runs = [];
  let pointer = 0;

  while (pointer < compressedCounts.length) {
    let value = 0;
    let shift = 0;
    let current;

    do {
      current = compressedCounts.charCodeAt(pointer) - 48;
      value += (current & 0x1f) * (2 ** shift);
      shift += 5;
      pointer += 1;
    } while (current & 0x20);

    if (current & 0x10) {
      value -= 2 ** shift;
    }

    if (runs.length > 1) {
      value += runs[runs.length - 2];
    }

    runs.push(value);
  }

  return runs;
}

function expandRunsToMask(runs, height, width) {
  const total = height * width;
  const maskColumnMajor = new Uint8ClampedArray(total);

  let pointer = 0;
  let pixelValue = 0;

  for (let runIndex = 0; runIndex < runs.length; runIndex += 1) {
    const runLength = Number(runs[runIndex]) || 0;
    const end = Math.min(pointer + runLength, total);

    while (pointer < end) {
      maskColumnMajor[pointer] = pixelValue;
      pointer += 1;
    }

    pixelValue = 1 - pixelValue;
    if (pointer >= total) {
      break;
    }
  }

  const maskRowMajor = new Uint8ClampedArray(total);
  for (let columnMajorIndex = 0; columnMajorIndex < total; columnMajorIndex += 1) {
    const row = columnMajorIndex % height;
    const column = Math.floor(columnMajorIndex / height);
    if (column >= width) {
      break;
    }
    const rowMajorIndex = row * width + column;
    maskRowMajor[rowMajorIndex] = maskColumnMajor[columnMajorIndex];
  }

  return maskRowMajor;
}

export function decodeRLE(rle) {
  if (!rle || !Array.isArray(rle.size) || rle.size.length < 2) {
    return new Uint8ClampedArray(0);
  }

  const [height, width] = rle.size;
  const counts = rle.counts;

  let runs;
  if (Array.isArray(counts)) {
    runs = counts;
  } else if (typeof counts === 'string') {
    runs = decodeCompressedCounts(counts);
  } else {
    return new Uint8ClampedArray(width * height);
  }

  return expandRunsToMask(runs, height, width);
}